/* Extracted from sections/product-recommendations.liquid on 2026-08-15.
   Was inline in every document that renders this file; now fetched once and
   cached. Deferred, so it runs after the DOM is parsed rather than at its old
   position — safer for the DOM queries inside, not riskier.
   No Liquid in here, which is why it could move at all. */

/* De-dupe across the two PDP recommendation rows: the merchandised
     "complementary" row wins; duplicates are removed from the "related" row.
     Runs once globally (the section renders twice per PDP). */
  (function () {
    if (window.__scwRecsDedupInit) return;
    window.__scwRecsDedupInit = true;

    function productKey(card) {
      var link = card.querySelector('a[href*="/products/"]');
      return link ? link.pathname : null;
    }

    function dedupe() {
      var related = document.querySelector('product-recommendations[data-intent="related"]');
      var complementary = document.querySelector('product-recommendations[data-intent="complementary"]');
      if (!related || !complementary) return;

      var keep = {};
      for (var card of complementary.querySelectorAll('.product-recs__card')) {
        var key = productKey(card);
        if (key) keep[key] = true;
      }
      if (!Object.keys(keep).length) return;

      for (var relCard of related.querySelectorAll('.product-recs__card')) {
        var relKey = productKey(relCard);
        if (relKey && keep[relKey]) relCard.remove();
      }
      if (!related.querySelector('.product-recs__card:not(.product-recs__skeleton)')) {
        related.classList.add('hidden');
      }
    }

    function init() {
      var observer = new MutationObserver(dedupe);
      var sections = document.querySelectorAll('product-recommendations');
      for (var section of sections) {
        observer.observe(section, { attributes: true, attributeFilter: ['data-recommendations-performed'] });
      }
      dedupe();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
